/**
 * Avaliador de permissao compartilhado entre API e UI.
 *
 * A API usa `can()` como camada 1 (guard de rota) e complementa com escopo de
 * registro e filtro de consulta. A UI usa o MESMO `can()` para esconder acoes —
 * conveniencia visual, nunca controle de acesso (SPEC.md secao 5.4).
 */
import { isScoped } from './permissions.js';
export function can(principal, permission) {
    if (!principal)
        return false;
    return principal.permissions.includes(permission);
}
export function canAny(principal, permissions) {
    if (!principal)
        return false;
    return permissions.some((p) => principal.permissions.includes(p));
}
export function canAll(principal, permissions) {
    if (!principal)
        return false;
    return permissions.every((p) => principal.permissions.includes(p));
}
/**
 * Camada 2: a permissao existe E o registro pertence ao requisitante.
 *
 * Para permissao nao escopada, o resultado e o mesmo de `can()`. Para permissao
 * `:own`, exige que o usuario seja o dono direto ou membro da organizacao dona.
 */
export function canOnResource(principal, permission, owner) {
    if (!can(principal, permission))
        return false;
    if (!isScoped(permission))
        return true;
    const p = principal;
    if (owner.ownerUserId && owner.ownerUserId === p.userId)
        return true;
    if (owner.ownerOrgId && p.orgIds.includes(owner.ownerOrgId))
        return true;
    return false;
}
export function hasRole(principal, role) {
    return principal?.roles.includes(role) ?? false;
}
//# sourceMappingURL=can.js.map